export function PhoneDeviceAdmin({ ...rest }) {
  return (
    <svg {...rest} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.41667 19.25C5.90417 19.25 5.46528 19.0681 5.1 18.7042C4.73472 18.3403 4.55208 17.9014 4.55208 17.3875V4.6125C4.55208 4.09861 4.73472 3.65972 5.1 3.29583C5.46528 2.93194 5.90417 2.75 6.41667 2.75H15.5833C16.0958 2.75 16.5347 2.93194 16.9 3.29583C17.2653 3.65972 17.4479 4.09861 17.4479 4.6125V17.3875C17.4479 17.9014 17.2653 18.3403 16.9 18.7042C16.5347 19.0681 16.0958 19.25 15.5833 19.25H6.41667ZM6.41667 16.5V17.4167H15.5833V16.5H6.41667ZM6.41667 14.6667H15.5833V5.5H6.41667V14.6667ZM6.41667 3.66667H15.5833V4.58333H6.41667V3.66667Z"
        fill="#666666"
      />
    </svg>
  );
}
